import { Component, OnDestroy } from '@angular/core';
import { ActivatedRoute, Data } from '@angular/router';
import { Store } from '@ngrx/store';
import { Subscription } from 'rxjs';
import { map } from 'rxjs/operators';

import { IRateSearch } from '@ruby/modules/rate-inquiry/models/rate-inquiry.interface';
import * as RateCoreActions from '@ruby/modules/rate-inquiry/store/actions/rate-core.actions';
import * as fromRateCore from '@ruby/modules/rate-inquiry/store/reducers/rate-core.reducer';
import { ITransaction } from '@ruby/shared/models/commons/transaction.interface';
import { IFavoriteData } from '@ruby/shared/models/favorites/favorites.interface';
import { UtilsService } from '@ruby/shared/services/utils/utils.service';

@Component({
  selector: 'ng-rate-container',
  templateUrl: './rate.container.html',
  styleUrls: ['./rate.container.scss']
})
export class RateContainerComponent implements OnDestroy {
  acrSubscription!: Subscription;

  constructor(private store: Store<fromRateCore.State>, private acr: ActivatedRoute, private utilSvc: UtilsService) {
    this.acrSubscription = this.acr.data.pipe(
      map((data: Data) => data.transaction)
    ).subscribe((query: ITransaction) => {
      if (query && query.parameters.favorite) {
        const favorite = JSON.parse(query.parameters.favorite);
        const selectedFavorite = favorite.favorite;
        const fav: IFavoriteData = this.utilSvc.deserializeFavorite(selectedFavorite);
        const favContent = fav.content as Array<IRateSearch>;
        this.store.dispatch(RateCoreActions.setRateSearchList({ data: favContent }));
        this.store.dispatch(RateCoreActions.setInquiryList({ data: favContent.length }));
        this.store.dispatch(RateCoreActions.setDisplayList({ data: true }));
      }
    });
  }

  ngOnDestroy(): void {
    this.acrSubscription.unsubscribe();
  }
}
